import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ExternalRefreshNotifierConfig, ExternalRefreshRequestStates } from 'src/app/core/interfaces/external-refresh-notifier';
import { ExternalRefreshNotifierService } from 'src/app/core/services/external-refresh-notifier.service';
import { Subscription } from 'rxjs';

// UIs should not be updated when a user is viewing them in case they are in the middle of
// something. Put this notification on top of the page to let the user decide when to update the page
// I tried to make this generic, but I think this will only work for one async job at a time now. Why? Because
// this component and the events it handles are not tied to a url/ feature so it is not
// tied to context. It would need to be to be totally effective. Need to think about this when the need
// arises. Maybe pass the context url and have the component check the url on the page it is loaded on?
// Also I am not handling more than one notice at a time and I think for now that is OK
@Component({
  selector: 'external-refresh-notifier',
  templateUrl: './external-refresh-notifier.component.html',
  styleUrls: ['./external-refresh-notifier.component.scss']
})

export class ExternalRefreshNotifierComponent implements OnInit, OnDestroy {
  @Input() externalStyles: any = {};


  showAlert: boolean = false;
  errMsgStyle: any = undefined;
  alertConfig: ExternalRefreshNotifierConfig;
  subscription: Subscription = new Subscription();

  constructor(
    public translateSvc: TranslateService,
    public refreshService: ExternalRefreshNotifierService) { }

  ngOnInit(): void {
    // the sole purpose of this component is to listen for a request to refresh and to show the message
    // when the user click the refresh link, it will emit an event
    // I have only implemented this as a 1 alert system per page. If requirements change, this should too
    this.subscription.add(this.refreshService.notifyExternalRefreshRequired.subscribe( config => {
      this.initRefreshNotification(config);
    }));

    this.subscription.add(this.refreshService.externalRefreshUpdate.subscribe(data=> {
      if ( data.state == ExternalRefreshRequestStates.COMPLETE )
      {
        this.alertConfig = undefined;
        this.showAlert = false;
      }
    }));
  }

  initRefreshNotification(config: ExternalRefreshNotifierConfig)
  {
    this.alertConfig = config;
    this.showAlert = true;
    this.refreshService.externalRefreshIsPending(config.emittedData);
  }
  
  handleRefreshActionClicked() {
    this.showAlert = false;
    this.refreshService.userRequestsRefresh(this.alertConfig.emittedData);
    this.alertConfig = undefined;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}